import { useUsersApi } from "@/setup/api";

export const fetchCurrentUser = () => useUsersApi().retrieve();
